/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const SpellCard = $root.SpellCard = (() => {

    /**
     * Namespace SpellCard.
     * @exports SpellCard
     * @namespace
     */
    const SpellCard = {};

    SpellCard.ExtraSpells = (function() {

        /**
         * Properties of an ExtraSpells.
         * @memberof SpellCard
         * @interface IExtraSpells
         * @property {Array.<string>|null} [domain] ExtraSpells domain
         * @property {Array.<string>|null} [patron] ExtraSpells patron
         * @property {Array.<string>|null} [bloodline] ExtraSpells bloodline
         */

        /**
         * Constructs a new ExtraSpells.
         * @memberof SpellCard
         * @classdesc Represents an ExtraSpells.
         * @implements IExtraSpells
         * @constructor
         * @param {SpellCard.IExtraSpells=} [properties] Properties to set
         */
        function ExtraSpells(properties) {
            this.domain = [];
            this.patron = [];
            this.bloodline = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExtraSpells domain.
         * @member {Array.<string>} domain
         * @memberof SpellCard.ExtraSpells
         * @instance
         */
        ExtraSpells.prototype.domain = $util.emptyArray;

        /**
         * ExtraSpells patron.
         * @member {Array.<string>} patron
         * @memberof SpellCard.ExtraSpells
         * @instance
         */
        ExtraSpells.prototype.patron = $util.emptyArray;

        /**
         * ExtraSpells bloodline.
         * @member {Array.<string>} bloodline
         * @memberof SpellCard.ExtraSpells
         * @instance
         */
        ExtraSpells.prototype.bloodline = $util.emptyArray;

        /**
         * Creates a new ExtraSpells instance using the specified properties.
         * @function create
         * @memberof SpellCard.ExtraSpells
         * @static
         * @param {SpellCard.IExtraSpells=} [properties] Properties to set
         * @returns {SpellCard.ExtraSpells} ExtraSpells instance
         */
        ExtraSpells.create = function create(properties) {
            return new ExtraSpells(properties);
        };

        /**
         * Encodes the specified ExtraSpells message. Does not implicitly {@link SpellCard.ExtraSpells.verify|verify} messages.
         * @function encode
         * @memberof SpellCard.ExtraSpells
         * @static
         * @param {SpellCard.IExtraSpells} message ExtraSpells message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExtraSpells.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.domain != null && message.domain.length)
                for (let i = 0; i < message.domain.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.domain[i]);
            if (message.patron != null && message.patron.length)
                for (let i = 0; i < message.patron.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.patron[i]);
            if (message.bloodline != null && message.bloodline.length)
                for (let i = 0; i < message.bloodline.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.bloodline[i]);
            return writer;
        };

        /**
         * Encodes the specified ExtraSpells message, length delimited. Does not implicitly {@link SpellCard.ExtraSpells.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SpellCard.ExtraSpells
         * @static
         * @param {SpellCard.IExtraSpells} message ExtraSpells message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExtraSpells.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ExtraSpells message from the specified reader or buffer.
         * @function decode
         * @memberof SpellCard.ExtraSpells
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {SpellCard.ExtraSpells} ExtraSpells
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExtraSpells.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SpellCard.ExtraSpells();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.domain && message.domain.length))
                        message.domain = [];
                    message.domain.push(reader.string());
                    break;
                case 2:
                    if (!(message.patron && message.patron.length))
                        message.patron = [];
                    message.patron.push(reader.string());
                    break;
                case 3:
                    if (!(message.bloodline && message.bloodline.length))
                        message.bloodline = [];
                    message.bloodline.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ExtraSpells message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SpellCard.ExtraSpells
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SpellCard.ExtraSpells} ExtraSpells
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExtraSpells.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExtraSpells message.
         * @function verify
         * @memberof SpellCard.ExtraSpells
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExtraSpells.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.domain != null && message.hasOwnProperty("domain")) {
                if (!Array.isArray(message.domain))
                    return "domain: array expected";
                for (let i = 0; i < message.domain.length; ++i)
                    if (!$util.isString(message.domain[i]))
                        return "domain: string[] expected";
            }
            if (message.patron != null && message.hasOwnProperty("patron")) {
                if (!Array.isArray(message.patron))
                    return "patron: array expected";
                for (let i = 0; i < message.patron.length; ++i)
                    if (!$util.isString(message.patron[i]))
                        return "patron: string[] expected";
            }
            if (message.bloodline != null && message.hasOwnProperty("bloodline")) {
                if (!Array.isArray(message.bloodline))
                    return "bloodline: array expected";
                for (let i = 0; i < message.bloodline.length; ++i)
                    if (!$util.isString(message.bloodline[i]))
                        return "bloodline: string[] expected";
            }
            return null;
        };

        /**
         * Creates an ExtraSpells message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof SpellCard.ExtraSpells
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {SpellCard.ExtraSpells} ExtraSpells
         */
        ExtraSpells.fromObject = function fromObject(object) {
            if (object instanceof $root.SpellCard.ExtraSpells)
                return object;
            let message = new $root.SpellCard.ExtraSpells();
            if (object.domain) {
                if (!Array.isArray(object.domain))
                    throw TypeError(".SpellCard.ExtraSpells.domain: array expected");
                message.domain = [];
                for (let i = 0; i < object.domain.length; ++i)
                    message.domain[i] = String(object.domain[i]);
            }
            if (object.patron) {
                if (!Array.isArray(object.patron))
                    throw TypeError(".SpellCard.ExtraSpells.patron: array expected");
                message.patron = [];
                for (let i = 0; i < object.patron.length; ++i)
                    message.patron[i] = String(object.patron[i]);
            }
            if (object.bloodline) {
                if (!Array.isArray(object.bloodline))
                    throw TypeError(".SpellCard.ExtraSpells.bloodline: array expected");
                message.bloodline = [];
                for (let i = 0; i < object.bloodline.length; ++i)
                    message.bloodline[i] = String(object.bloodline[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an ExtraSpells message. Also converts values to other types if specified.
         * @function toObject
         * @memberof SpellCard.ExtraSpells
         * @static
         * @param {SpellCard.ExtraSpells} message ExtraSpells
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExtraSpells.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.domain = [];
                object.patron = [];
                object.bloodline = [];
            }
            if (message.domain && message.domain.length) {
                object.domain = [];
                for (let j = 0; j < message.domain.length; ++j)
                    object.domain[j] = message.domain[j];
            }
            if (message.patron && message.patron.length) {
                object.patron = [];
                for (let j = 0; j < message.patron.length; ++j)
                    object.patron[j] = message.patron[j];
            }
            if (message.bloodline && message.bloodline.length) {
                object.bloodline = [];
                for (let j = 0; j < message.bloodline.length; ++j)
                    object.bloodline[j] = message.bloodline[j];
            }
            return object;
        };

        /**
         * Converts this ExtraSpells to JSON.
         * @function toJSON
         * @memberof SpellCard.ExtraSpells
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExtraSpells.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ExtraSpells;
    })();

    SpellCard.Spellbook = (function() {

        /**
         * Properties of a Spellbook.
         * @memberof SpellCard
         * @interface ISpellbook
         * @property {string} caster Spellbook caster
         * @property {string|null} [name] Spellbook name
         * @property {Array.<number>|null} [spells] Spellbook spells
         * @property {SpellCard.IExtraSpells|null} [extraSpells] Spellbook extraSpells
         */

        /**
         * Constructs a new Spellbook.
         * @memberof SpellCard
         * @classdesc Represents a Spellbook.
         * @implements ISpellbook
         * @constructor
         * @param {SpellCard.ISpellbook=} [properties] Properties to set
         */
        function Spellbook(properties) {
            this.spells = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Spellbook caster.
         * @member {string} caster
         * @memberof SpellCard.Spellbook
         * @instance
         */
        Spellbook.prototype.caster = "";

        /**
         * Spellbook name.
         * @member {string} name
         * @memberof SpellCard.Spellbook
         * @instance
         */
        Spellbook.prototype.name = "";

        /**
         * Spellbook spells.
         * @member {Array.<number>} spells
         * @memberof SpellCard.Spellbook
         * @instance
         */
        Spellbook.prototype.spells = $util.emptyArray;

        /**
         * Spellbook extraSpells.
         * @member {SpellCard.IExtraSpells|null|undefined} extraSpells
         * @memberof SpellCard.Spellbook
         * @instance
         */
        Spellbook.prototype.extraSpells = null;

        /**
         * Creates a new Spellbook instance using the specified properties.
         * @function create
         * @memberof SpellCard.Spellbook
         * @static
         * @param {SpellCard.ISpellbook=} [properties] Properties to set
         * @returns {SpellCard.Spellbook} Spellbook instance
         */
        Spellbook.create = function create(properties) {
            return new Spellbook(properties);
        };

        /**
         * Encodes the specified Spellbook message. Does not implicitly {@link SpellCard.Spellbook.verify|verify} messages.
         * @function encode
         * @memberof SpellCard.Spellbook
         * @static
         * @param {SpellCard.ISpellbook} message Spellbook message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Spellbook.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.caster);
            if (message.name != null && message.hasOwnProperty("name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.spells != null && message.spells.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (let i = 0; i < message.spells.length; ++i)
                    writer.int32(message.spells[i]);
                writer.ldelim();
            }
            if (message.extraSpells != null && message.hasOwnProperty("extraSpells"))
                $root.SpellCard.ExtraSpells.encode(message.extraSpells, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Spellbook message, length delimited. Does not implicitly {@link SpellCard.Spellbook.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SpellCard.Spellbook
         * @static
         * @param {SpellCard.ISpellbook} message Spellbook message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Spellbook.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Spellbook message from the specified reader or buffer.
         * @function decode
         * @memberof SpellCard.Spellbook
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {SpellCard.Spellbook} Spellbook
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Spellbook.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SpellCard.Spellbook();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.caster = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    if (!(message.spells && message.spells.length))
                        message.spells = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.spells.push(reader.int32());
                    } else
                        message.spells.push(reader.int32());
                    break;
                case 4:
                    message.extraSpells = $root.SpellCard.ExtraSpells.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("caster"))
                throw $util.ProtocolError("missing required 'caster'", { instance: message });
            return message;
        };

        /**
         * Decodes a Spellbook message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SpellCard.Spellbook
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SpellCard.Spellbook} Spellbook
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Spellbook.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Spellbook message.
         * @function verify
         * @memberof SpellCard.Spellbook
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Spellbook.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.caster))
                return "caster: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.spells != null && message.hasOwnProperty("spells")) {
                if (!Array.isArray(message.spells))
                    return "spells: array expected";
                for (let i = 0; i < message.spells.length; ++i)
                    if (!$util.isInteger(message.spells[i]))
                        return "spells: integer[] expected";
            }
            if (message.extraSpells != null && message.hasOwnProperty("extraSpells")) {
                let error = $root.SpellCard.ExtraSpells.verify(message.extraSpells);
                if (error)
                    return "extraSpells." + error;
            }
            return null;
        };

        /**
         * Creates a Spellbook message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof SpellCard.Spellbook
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {SpellCard.Spellbook} Spellbook
         */
        Spellbook.fromObject = function fromObject(object) {
            if (object instanceof $root.SpellCard.Spellbook)
                return object;
            let message = new $root.SpellCard.Spellbook();
            if (object.caster != null)
                message.caster = String(object.caster);
            if (object.name != null)
                message.name = String(object.name);
            if (object.spells) {
                if (!Array.isArray(object.spells))
                    throw TypeError(".SpellCard.Spellbook.spells: array expected");
                message.spells = [];
                for (let i = 0; i < object.spells.length; ++i)
                    message.spells[i] = object.spells[i] | 0;
            }
            if (object.extraSpells != null) {
                if (typeof object.extraSpells !== "object")
                    throw TypeError(".SpellCard.Spellbook.extraSpells: object expected");
                message.extraSpells = $root.SpellCard.ExtraSpells.fromObject(object.extraSpells);
            }
            return message;
        };

        /**
         * Creates a plain object from a Spellbook message. Also converts values to other types if specified.
         * @function toObject
         * @memberof SpellCard.Spellbook
         * @static
         * @param {SpellCard.Spellbook} message Spellbook
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Spellbook.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.spells = [];
            if (options.defaults) {
                object.caster = "";
                object.name = "";
                object.extraSpells = null;
            }
            if (message.caster != null && message.hasOwnProperty("caster"))
                object.caster = message.caster;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.spells && message.spells.length) {
                object.spells = [];
                for (let j = 0; j < message.spells.length; ++j)
                    object.spells[j] = message.spells[j];
            }
            if (message.extraSpells != null && message.hasOwnProperty("extraSpells"))
                object.extraSpells = $root.SpellCard.ExtraSpells.toObject(message.extraSpells, options);
            return object;
        };

        /**
         * Converts this Spellbook to JSON.
         * @function toJSON
         * @memberof SpellCard.Spellbook
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Spellbook.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Spellbook;
    })();

    SpellCard.AppRoot = (function() {

        /**
         * Properties of an AppRoot.
         * @memberof SpellCard
         * @interface IAppRoot
         * @property {number|null} [activeSpellbook] AppRoot activeSpellbook
         * @property {Array.<SpellCard.ISpellbook>|null} [spellbooks] AppRoot spellbooks
         * @property {boolean|null} [visible] AppRoot visible
         * @property {string|null} [query] AppRoot query
         * @property {number|null} [levelRange] AppRoot levelRange
         * @property {Array.<string>|null} [school] AppRoot school
         * @property {Array.<string>|null} [subschool] AppRoot subschool
         * @property {Array.<string>|null} [time] AppRoot time
         * @property {Array.<string>|null} [component] AppRoot component
         * @property {Array.<string>|null} [sourcebook] AppRoot sourcebook
         * @property {boolean|null} [inAlphaOrder] AppRoot inAlphaOrder
         * @property {boolean|null} [inSelection] AppRoot inSelection
         * @property {boolean|null} [inBrowser] AppRoot inBrowser
         * @property {boolean|null} [inEdit] AppRoot inEdit
         * @property {boolean|null} [searchSimilar] AppRoot searchSimilar
         * @property {Array.<string>|null} [type] AppRoot type
         * @property {Array.<string>|null} [tradition] AppRoot tradition
         * @property {Array.<string>|null} [action] AppRoot action
         * @property {Array.<string>|null} [schoolTrait] AppRoot schoolTrait
         * @property {Array.<string>|null} [classTrait] AppRoot classTrait
         * @property {Array.<string>|null} [rarityTrait] AppRoot rarityTrait
         * @property {Array.<string>|null} [trait] AppRoot trait
         * @property {Array.<string>|null} [save] AppRoot save
         * @property {Array.<number>|null} [spellRange] AppRoot spellRange
         */

        /**
         * Constructs a new AppRoot.
         * @memberof SpellCard
         * @classdesc Represents an AppRoot.
         * @implements IAppRoot
         * @constructor
         * @param {SpellCard.IAppRoot=} [properties] Properties to set
         */
        function AppRoot(properties) {
            this.spellbooks = [];
            this.school = [];
            this.subschool = [];
            this.time = [];
            this.component = [];
            this.sourcebook = [];
            this.type = [];
            this.tradition = [];
            this.action = [];
            this.schoolTrait = [];
            this.classTrait = [];
            this.rarityTrait = [];
            this.trait = [];
            this.save = [];
            this.spellRange = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AppRoot activeSpellbook.
         * @member {number} activeSpellbook
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.activeSpellbook = -1;

        /**
         * AppRoot spellbooks.
         * @member {Array.<SpellCard.ISpellbook>} spellbooks
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.spellbooks = $util.emptyArray;

        /**
         * AppRoot visible.
         * @member {boolean} visible
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.visible = true;

        /**
         * AppRoot query.
         * @member {string} query
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.query = "";

        /**
         * AppRoot levelRange.
         * @member {number} levelRange
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.levelRange = -1;

        /**
         * AppRoot school.
         * @member {Array.<string>} school
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.school = $util.emptyArray;

        /**
         * AppRoot subschool.
         * @member {Array.<string>} subschool
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.subschool = $util.emptyArray;

        /**
         * AppRoot time.
         * @member {Array.<string>} time
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.time = $util.emptyArray;

        /**
         * AppRoot component.
         * @member {Array.<string>} component
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.component = $util.emptyArray;

        /**
         * AppRoot sourcebook.
         * @member {Array.<string>} sourcebook
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.sourcebook = $util.emptyArray;

        /**
         * AppRoot inAlphaOrder.
         * @member {boolean} inAlphaOrder
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.inAlphaOrder = false;

        /**
         * AppRoot inSelection.
         * @member {boolean} inSelection
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.inSelection = false;

        /**
         * AppRoot inBrowser.
         * @member {boolean} inBrowser
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.inBrowser = true;

        /**
         * AppRoot inEdit.
         * @member {boolean} inEdit
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.inEdit = false;

        /**
         * AppRoot searchSimilar.
         * @member {boolean} searchSimilar
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.searchSimilar = false;

        /**
         * AppRoot type.
         * @member {Array.<string>} type
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.type = $util.emptyArray;

        /**
         * AppRoot tradition.
         * @member {Array.<string>} tradition
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.tradition = $util.emptyArray;

        /**
         * AppRoot action.
         * @member {Array.<string>} action
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.action = $util.emptyArray;

        /**
         * AppRoot schoolTrait.
         * @member {Array.<string>} schoolTrait
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.schoolTrait = $util.emptyArray;

        /**
         * AppRoot classTrait.
         * @member {Array.<string>} classTrait
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.classTrait = $util.emptyArray;

        /**
         * AppRoot rarityTrait.
         * @member {Array.<string>} rarityTrait
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.rarityTrait = $util.emptyArray;

        /**
         * AppRoot trait.
         * @member {Array.<string>} trait
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.trait = $util.emptyArray;

        /**
         * AppRoot save.
         * @member {Array.<string>} save
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.save = $util.emptyArray;

        /**
         * AppRoot spellRange.
         * @member {Array.<number>} spellRange
         * @memberof SpellCard.AppRoot
         * @instance
         */
        AppRoot.prototype.spellRange = $util.emptyArray;

        /**
         * Creates a new AppRoot instance using the specified properties.
         * @function create
         * @memberof SpellCard.AppRoot
         * @static
         * @param {SpellCard.IAppRoot=} [properties] Properties to set
         * @returns {SpellCard.AppRoot} AppRoot instance
         */
        AppRoot.create = function create(properties) {
            return new AppRoot(properties);
        };

        /**
         * Encodes the specified AppRoot message. Does not implicitly {@link SpellCard.AppRoot.verify|verify} messages.
         * @function encode
         * @memberof SpellCard.AppRoot
         * @static
         * @param {SpellCard.IAppRoot} message AppRoot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AppRoot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.activeSpellbook != null && message.hasOwnProperty("activeSpellbook"))
                writer.uint32(/* id 0, wireType 0 =*/0).int32(message.activeSpellbook);
            if (message.spellbooks != null && message.spellbooks.length)
                for (let i = 0; i < message.spellbooks.length; ++i)
                    $root.SpellCard.Spellbook.encode(message.spellbooks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.visible != null && message.hasOwnProperty("visible"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.visible);
            if (message.query != null && message.hasOwnProperty("query"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.query);
            if (message.levelRange != null && message.hasOwnProperty("levelRange"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.levelRange);
            if (message.school != null && message.school.length)
                for (let i = 0; i < message.school.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.school[i]);
            if (message.subschool != null && message.subschool.length)
                for (let i = 0; i < message.subschool.length; ++i)
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.subschool[i]);
            if (message.time != null && message.time.length)
                for (let i = 0; i < message.time.length; ++i)
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.time[i]);
            if (message.component != null && message.component.length)
                for (let i = 0; i < message.component.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.component[i]);
            if (message.sourcebook != null && message.sourcebook.length)
                for (let i = 0; i < message.sourcebook.length; ++i)
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.sourcebook[i]);
            if (message.inAlphaOrder != null && message.hasOwnProperty("inAlphaOrder"))
                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.inAlphaOrder);
            if (message.inSelection != null && message.hasOwnProperty("inSelection"))
                writer.uint32(/* id 11, wireType 0 =*/88).bool(message.inSelection);
            if (message.inBrowser != null && message.hasOwnProperty("inBrowser"))
                writer.uint32(/* id 12, wireType 0 =*/96).bool(message.inBrowser);
            if (message.inEdit != null && message.hasOwnProperty("inEdit"))
                writer.uint32(/* id 13, wireType 0 =*/104).bool(message.inEdit);
            if (message.searchSimilar != null && message.hasOwnProperty("searchSimilar"))
                writer.uint32(/* id 14, wireType 0 =*/112).bool(message.searchSimilar);
            if (message.type != null && message.type.length)
                for (let i = 0; i < message.type.length; ++i)
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.type[i]);
            if (message.tradition != null && message.tradition.length)
                for (let i = 0; i < message.tradition.length; ++i)
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.tradition[i]);
            if (message.action != null && message.action.length)
                for (let i = 0; i < message.action.length; ++i)
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.action[i]);
            if (message.schoolTrait != null && message.schoolTrait.length)
                for (let i = 0; i < message.schoolTrait.length; ++i)
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.schoolTrait[i]);
            if (message.classTrait != null && message.classTrait.length)
                for (let i = 0; i < message.classTrait.length; ++i)
                    writer.uint32(/* id 20, wireType 2 =*/162).string(message.classTrait[i]);
            if (message.rarityTrait != null && message.rarityTrait.length)
                for (let i = 0; i < message.rarityTrait.length; ++i)
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.rarityTrait[i]);
            if (message.trait != null && message.trait.length)
                for (let i = 0; i < message.trait.length; ++i)
                    writer.uint32(/* id 22, wireType 2 =*/178).string(message.trait[i]);
            if (message.save != null && message.save.length)
                for (let i = 0; i < message.save.length; ++i)
                    writer.uint32(/* id 23, wireType 2 =*/186).string(message.save[i]);
            if (message.spellRange != null && message.spellRange.length) {
                writer.uint32(/* id 24, wireType 2 =*/194).fork();
                for (let i = 0; i < message.spellRange.length; ++i)
                    writer.int32(message.spellRange[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified AppRoot message, length delimited. Does not implicitly {@link SpellCard.AppRoot.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SpellCard.AppRoot
         * @static
         * @param {SpellCard.IAppRoot} message AppRoot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AppRoot.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AppRoot message from the specified reader or buffer.
         * @function decode
         * @memberof SpellCard.AppRoot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {SpellCard.AppRoot} AppRoot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AppRoot.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SpellCard.AppRoot();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 0:
                    message.activeSpellbook = reader.int32();
                    break;
                case 1:
                    if (!(message.spellbooks && message.spellbooks.length))
                        message.spellbooks = [];
                    message.spellbooks.push($root.SpellCard.Spellbook.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.visible = reader.bool();
                    break;
                case 3:
                    message.query = reader.string();
                    break;
                case 4:
                    message.levelRange = reader.int32();
                    break;
                case 5:
                    if (!(message.school && message.school.length))
                        message.school = [];
                    message.school.push(reader.string());
                    break;
                case 6:
                    if (!(message.subschool && message.subschool.length))
                        message.subschool = [];
                    message.subschool.push(reader.string());
                    break;
                case 7:
                    if (!(message.time && message.time.length))
                        message.time = [];
                    message.time.push(reader.string());
                    break;
                case 8:
                    if (!(message.component && message.component.length))
                        message.component = [];
                    message.component.push(reader.string());
                    break;
                case 9:
                    if (!(message.sourcebook && message.sourcebook.length))
                        message.sourcebook = [];
                    message.sourcebook.push(reader.string());
                    break;
                case 10:
                    message.inAlphaOrder = reader.bool();
                    break;
                case 11:
                    message.inSelection = reader.bool();
                    break;
                case 12:
                    message.inBrowser = reader.bool();
                    break;
                case 13:
                    message.inEdit = reader.bool();
                    break;
                case 14:
                    message.searchSimilar = reader.bool();
                    break;
                case 16:
                    if (!(message.type && message.type.length))
                        message.type = [];
                    message.type.push(reader.string());
                    break;
                case 17:
                    if (!(message.tradition && message.tradition.length))
                        message.tradition = [];
                    message.tradition.push(reader.string());
                    break;
                case 18:
                    if (!(message.action && message.action.length))
                        message.action = [];
                    message.action.push(reader.string());
                    break;
                case 19:
                    if (!(message.schoolTrait && message.schoolTrait.length))
                        message.schoolTrait = [];
                    message.schoolTrait.push(reader.string());
                    break;
                case 20:
                    if (!(message.classTrait && message.classTrait.length))
                        message.classTrait = [];
                    message.classTrait.push(reader.string());
                    break;
                case 21:
                    if (!(message.rarityTrait && message.rarityTrait.length))
                        message.rarityTrait = [];
                    message.rarityTrait.push(reader.string());
                    break;
                case 22:
                    if (!(message.trait && message.trait.length))
                        message.trait = [];
                    message.trait.push(reader.string());
                    break;
                case 23:
                    if (!(message.save && message.save.length))
                        message.save = [];
                    message.save.push(reader.string());
                    break;
                case 24:
                    if (!(message.spellRange && message.spellRange.length))
                        message.spellRange = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.spellRange.push(reader.int32());
                    } else
                        message.spellRange.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AppRoot message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SpellCard.AppRoot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SpellCard.AppRoot} AppRoot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AppRoot.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AppRoot message.
         * @function verify
         * @memberof SpellCard.AppRoot
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AppRoot.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.activeSpellbook != null && message.hasOwnProperty("activeSpellbook"))
                if (!$util.isInteger(message.activeSpellbook))
                    return "activeSpellbook: integer expected";
            if (message.spellbooks != null && message.hasOwnProperty("spellbooks")) {
                if (!Array.isArray(message.spellbooks))
                    return "spellbooks: array expected";
                for (let i = 0; i < message.spellbooks.length; ++i) {
                    let error = $root.SpellCard.Spellbook.verify(message.spellbooks[i]);
                    if (error)
                        return "spellbooks." + error;
                }
            }
            if (message.visible != null && message.hasOwnProperty("visible"))
                if (typeof message.visible !== "boolean")
                    return "visible: boolean expected";
            if (message.query != null && message.hasOwnProperty("query"))
                if (!$util.isString(message.query))
                    return "query: string expected";
            if (message.levelRange != null && message.hasOwnProperty("levelRange"))
                if (!$util.isInteger(message.levelRange))
                    return "levelRange: integer expected";
            if (message.school != null && message.hasOwnProperty("school")) {
                if (!Array.isArray(message.school))
                    return "school: array expected";
                for (let i = 0; i < message.school.length; ++i)
                    if (!$util.isString(message.school[i]))
                        return "school: string[] expected";
            }
            if (message.subschool != null && message.hasOwnProperty("subschool")) {
                if (!Array.isArray(message.subschool))
                    return "subschool: array expected";
                for (let i = 0; i < message.subschool.length; ++i)
                    if (!$util.isString(message.subschool[i]))
                        return "subschool: string[] expected";
            }
            if (message.time != null && message.hasOwnProperty("time")) {
                if (!Array.isArray(message.time))
                    return "time: array expected";
                for (let i = 0; i < message.time.length; ++i)
                    if (!$util.isString(message.time[i]))
                        return "time: string[] expected";
            }
            if (message.component != null && message.hasOwnProperty("component")) {
                if (!Array.isArray(message.component))
                    return "component: array expected";
                for (let i = 0; i < message.component.length; ++i)
                    if (!$util.isString(message.component[i]))
                        return "component: string[] expected";
            }
            if (message.sourcebook != null && message.hasOwnProperty("sourcebook")) {
                if (!Array.isArray(message.sourcebook))
                    return "sourcebook: array expected";
                for (let i = 0; i < message.sourcebook.length; ++i)
                    if (!$util.isString(message.sourcebook[i]))
                        return "sourcebook: string[] expected";
            }
            if (message.inAlphaOrder != null && message.hasOwnProperty("inAlphaOrder"))
                if (typeof message.inAlphaOrder !== "boolean")
                    return "inAlphaOrder: boolean expected";
            if (message.inSelection != null && message.hasOwnProperty("inSelection"))
                if (typeof message.inSelection !== "boolean")
                    return "inSelection: boolean expected";
            if (message.inBrowser != null && message.hasOwnProperty("inBrowser"))
                if (typeof message.inBrowser !== "boolean")
                    return "inBrowser: boolean expected";
            if (message.inEdit != null && message.hasOwnProperty("inEdit"))
                if (typeof message.inEdit !== "boolean")
                    return "inEdit: boolean expected";
            if (message.searchSimilar != null && message.hasOwnProperty("searchSimilar"))
                if (typeof message.searchSimilar !== "boolean")
                    return "searchSimilar: boolean expected";
            if (message.type != null && message.hasOwnProperty("type")) {
                if (!Array.isArray(message.type))
                    return "type: array expected";
                for (let i = 0; i < message.type.length; ++i)
                    if (!$util.isString(message.type[i]))
                        return "type: string[] expected";
            }
            if (message.tradition != null && message.hasOwnProperty("tradition")) {
                if (!Array.isArray(message.tradition))
                    return "tradition: array expected";
                for (let i = 0; i < message.tradition.length; ++i)
                    if (!$util.isString(message.tradition[i]))
                        return "tradition: string[] expected";
            }
            if (message.action != null && message.hasOwnProperty("action")) {
                if (!Array.isArray(message.action))
                    return "action: array expected";
                for (let i = 0; i < message.action.length; ++i)
                    if (!$util.isString(message.action[i]))
                        return "action: string[] expected";
            }
            if (message.schoolTrait != null && message.hasOwnProperty("schoolTrait")) {
                if (!Array.isArray(message.schoolTrait))
                    return "schoolTrait: array expected";
                for (let i = 0; i < message.schoolTrait.length; ++i)
                    if (!$util.isString(message.schoolTrait[i]))
                        return "schoolTrait: string[] expected";
            }
            if (message.classTrait != null && message.hasOwnProperty("classTrait")) {
                if (!Array.isArray(message.classTrait))
                    return "classTrait: array expected";
                for (let i = 0; i < message.classTrait.length; ++i)
                    if (!$util.isString(message.classTrait[i]))
                        return "classTrait: string[] expected";
            }
            if (message.rarityTrait != null && message.hasOwnProperty("rarityTrait")) {
                if (!Array.isArray(message.rarityTrait))
                    return "rarityTrait: array expected";
                for (let i = 0; i < message.rarityTrait.length; ++i)
                    if (!$util.isString(message.rarityTrait[i]))
                        return "rarityTrait: string[] expected";
            }
            if (message.trait != null && message.hasOwnProperty("trait")) {
                if (!Array.isArray(message.trait))
                    return "trait: array expected";
                for (let i = 0; i < message.trait.length; ++i)
                    if (!$util.isString(message.trait[i]))
                        return "trait: string[] expected";
            }
            if (message.save != null && message.hasOwnProperty("save")) {
                if (!Array.isArray(message.save))
                    return "save: array expected";
                for (let i = 0; i < message.save.length; ++i)
                    if (!$util.isString(message.save[i]))
                        return "save: string[] expected";
            }
            if (message.spellRange != null && message.hasOwnProperty("spellRange")) {
                if (!Array.isArray(message.spellRange))
                    return "spellRange: array expected";
                for (let i = 0; i < message.spellRange.length; ++i)
                    if (!$util.isInteger(message.spellRange[i]))
                        return "spellRange: integer[] expected";
            }
            return null;
        };

        /**
         * Creates an AppRoot message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof SpellCard.AppRoot
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {SpellCard.AppRoot} AppRoot
         */
        AppRoot.fromObject = function fromObject(object) {
            if (object instanceof $root.SpellCard.AppRoot)
                return object;
            let message = new $root.SpellCard.AppRoot();
            if (object.activeSpellbook != null)
                message.activeSpellbook = object.activeSpellbook | 0;
            if (object.spellbooks) {
                if (!Array.isArray(object.spellbooks))
                    throw TypeError(".SpellCard.AppRoot.spellbooks: array expected");
                message.spellbooks = [];
                for (let i = 0; i < object.spellbooks.length; ++i) {
                    if (typeof object.spellbooks[i] !== "object")
                        throw TypeError(".SpellCard.AppRoot.spellbooks: object expected");
                    message.spellbooks[i] = $root.SpellCard.Spellbook.fromObject(object.spellbooks[i]);
                }
            }
            if (object.visible != null)
                message.visible = Boolean(object.visible);
            if (object.query != null)
                message.query = String(object.query);
            if (object.levelRange != null)
                message.levelRange = object.levelRange | 0;
            if (object.school) {
                if (!Array.isArray(object.school))
                    throw TypeError(".SpellCard.AppRoot.school: array expected");
                message.school = [];
                for (let i = 0; i < object.school.length; ++i)
                    message.school[i] = String(object.school[i]);
            }
            if (object.subschool) {
                if (!Array.isArray(object.subschool))
                    throw TypeError(".SpellCard.AppRoot.subschool: array expected");
                message.subschool = [];
                for (let i = 0; i < object.subschool.length; ++i)
                    message.subschool[i] = String(object.subschool[i]);
            }
            if (object.time) {
                if (!Array.isArray(object.time))
                    throw TypeError(".SpellCard.AppRoot.time: array expected");
                message.time = [];
                for (let i = 0; i < object.time.length; ++i)
                    message.time[i] = String(object.time[i]);
            }
            if (object.component) {
                if (!Array.isArray(object.component))
                    throw TypeError(".SpellCard.AppRoot.component: array expected");
                message.component = [];
                for (let i = 0; i < object.component.length; ++i)
                    message.component[i] = String(object.component[i]);
            }
            if (object.sourcebook) {
                if (!Array.isArray(object.sourcebook))
                    throw TypeError(".SpellCard.AppRoot.sourcebook: array expected");
                message.sourcebook = [];
                for (let i = 0; i < object.sourcebook.length; ++i)
                    message.sourcebook[i] = String(object.sourcebook[i]);
            }
            if (object.inAlphaOrder != null)
                message.inAlphaOrder = Boolean(object.inAlphaOrder);
            if (object.inSelection != null)
                message.inSelection = Boolean(object.inSelection);
            if (object.inBrowser != null)
                message.inBrowser = Boolean(object.inBrowser);
            if (object.inEdit != null)
                message.inEdit = Boolean(object.inEdit);
            if (object.searchSimilar != null)
                message.searchSimilar = Boolean(object.searchSimilar);
            if (object.type) {
                if (!Array.isArray(object.type))
                    throw TypeError(".SpellCard.AppRoot.type: array expected");
                message.type = [];
                for (let i = 0; i < object.type.length; ++i)
                    message.type[i] = String(object.type[i]);
            }
            if (object.tradition) {
                if (!Array.isArray(object.tradition))
                    throw TypeError(".SpellCard.AppRoot.tradition: array expected");
                message.tradition = [];
                for (let i = 0; i < object.tradition.length; ++i)
                    message.tradition[i] = String(object.tradition[i]);
            }
            if (object.action) {
                if (!Array.isArray(object.action))
                    throw TypeError(".SpellCard.AppRoot.action: array expected");
                message.action = [];
                for (let i = 0; i < object.action.length; ++i)
                    message.action[i] = String(object.action[i]);
            }
            if (object.schoolTrait) {
                if (!Array.isArray(object.schoolTrait))
                    throw TypeError(".SpellCard.AppRoot.schoolTrait: array expected");
                message.schoolTrait = [];
                for (let i = 0; i < object.schoolTrait.length; ++i)
                    message.schoolTrait[i] = String(object.schoolTrait[i]);
            }
            if (object.classTrait) {
                if (!Array.isArray(object.classTrait))
                    throw TypeError(".SpellCard.AppRoot.classTrait: array expected");
                message.classTrait = [];
                for (let i = 0; i < object.classTrait.length; ++i)
                    message.classTrait[i] = String(object.classTrait[i]);
            }
            if (object.rarityTrait) {
                if (!Array.isArray(object.rarityTrait))
                    throw TypeError(".SpellCard.AppRoot.rarityTrait: array expected");
                message.rarityTrait = [];
                for (let i = 0; i < object.rarityTrait.length; ++i)
                    message.rarityTrait[i] = String(object.rarityTrait[i]);
            }
            if (object.trait) {
                if (!Array.isArray(object.trait))
                    throw TypeError(".SpellCard.AppRoot.trait: array expected");
                message.trait = [];
                for (let i = 0; i < object.trait.length; ++i)
                    message.trait[i] = String(object.trait[i]);
            }
            if (object.save) {
                if (!Array.isArray(object.save))
                    throw TypeError(".SpellCard.AppRoot.save: array expected");
                message.save = [];
                for (let i = 0; i < object.save.length; ++i)
                    message.save[i] = String(object.save[i]);
            }
            if (object.spellRange) {
                if (!Array.isArray(object.spellRange))
                    throw TypeError(".SpellCard.AppRoot.spellRange: array expected");
                message.spellRange = [];
                for (let i = 0; i < object.spellRange.length; ++i)
                    message.spellRange[i] = object.spellRange[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from an AppRoot message. Also converts values to other types if specified.
         * @function toObject
         * @memberof SpellCard.AppRoot
         * @static
         * @param {SpellCard.AppRoot} message AppRoot
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AppRoot.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.spellbooks = [];
                object.school = [];
                object.subschool = [];
                object.time = [];
                object.component = [];
                object.sourcebook = [];
                object.type = [];
                object.tradition = [];
                object.action = [];
                object.schoolTrait = [];
                object.classTrait = [];
                object.rarityTrait = [];
                object.trait = [];
                object.save = [];
                object.spellRange = [];
            }
            if (options.defaults) {
                object.activeSpellbook = -1;
                object.visible = true;
                object.query = "";
                object.levelRange = -1;
                object.inAlphaOrder = false;
                object.inSelection = false;
                object.inBrowser = true;
                object.inEdit = false;
                object.searchSimilar = false;
            }
            if (message.activeSpellbook != null && message.hasOwnProperty("activeSpellbook"))
                object.activeSpellbook = message.activeSpellbook;
            if (message.spellbooks && message.spellbooks.length) {
                object.spellbooks = [];
                for (let j = 0; j < message.spellbooks.length; ++j)
                    object.spellbooks[j] = $root.SpellCard.Spellbook.toObject(message.spellbooks[j], options);
            }
            if (message.visible != null && message.hasOwnProperty("visible"))
                object.visible = message.visible;
            if (message.query != null && message.hasOwnProperty("query"))
                object.query = message.query;
            if (message.levelRange != null && message.hasOwnProperty("levelRange"))
                object.levelRange = message.levelRange;
            if (message.school && message.school.length) {
                object.school = [];
                for (let j = 0; j < message.school.length; ++j)
                    object.school[j] = message.school[j];
            }
            if (message.subschool && message.subschool.length) {
                object.subschool = [];
                for (let j = 0; j < message.subschool.length; ++j)
                    object.subschool[j] = message.subschool[j];
            }
            if (message.time && message.time.length) {
                object.time = [];
                for (let j = 0; j < message.time.length; ++j)
                    object.time[j] = message.time[j];
            }
            if (message.component && message.component.length) {
                object.component = [];
                for (let j = 0; j < message.component.length; ++j)
                    object.component[j] = message.component[j];
            }
            if (message.sourcebook && message.sourcebook.length) {
                object.sourcebook = [];
                for (let j = 0; j < message.sourcebook.length; ++j)
                    object.sourcebook[j] = message.sourcebook[j];
            }
            if (message.inAlphaOrder != null && message.hasOwnProperty("inAlphaOrder"))
                object.inAlphaOrder = message.inAlphaOrder;
            if (message.inSelection != null && message.hasOwnProperty("inSelection"))
                object.inSelection = message.inSelection;
            if (message.inBrowser != null && message.hasOwnProperty("inBrowser"))
                object.inBrowser = message.inBrowser;
            if (message.inEdit != null && message.hasOwnProperty("inEdit"))
                object.inEdit = message.inEdit;
            if (message.searchSimilar != null && message.hasOwnProperty("searchSimilar"))
                object.searchSimilar = message.searchSimilar;
            if (message.type && message.type.length) {
                object.type = [];
                for (let j = 0; j < message.type.length; ++j)
                    object.type[j] = message.type[j];
            }
            if (message.tradition && message.tradition.length) {
                object.tradition = [];
                for (let j = 0; j < message.tradition.length; ++j)
                    object.tradition[j] = message.tradition[j];
            }
            if (message.action && message.action.length) {
                object.action = [];
                for (let j = 0; j < message.action.length; ++j)
                    object.action[j] = message.action[j];
            }
            if (message.schoolTrait && message.schoolTrait.length) {
                object.schoolTrait = [];
                for (let j = 0; j < message.schoolTrait.length; ++j)
                    object.schoolTrait[j] = message.schoolTrait[j];
            }
            if (message.classTrait && message.classTrait.length) {
                object.classTrait = [];
                for (let j = 0; j < message.classTrait.length; ++j)
                    object.classTrait[j] = message.classTrait[j];
            }
            if (message.rarityTrait && message.rarityTrait.length) {
                object.rarityTrait = [];
                for (let j = 0; j < message.rarityTrait.length; ++j)
                    object.rarityTrait[j] = message.rarityTrait[j];
            }
            if (message.trait && message.trait.length) {
                object.trait = [];
                for (let j = 0; j < message.trait.length; ++j)
                    object.trait[j] = message.trait[j];
            }
            if (message.save && message.save.length) {
                object.save = [];
                for (let j = 0; j < message.save.length; ++j)
                    object.save[j] = message.save[j];
            }
            if (message.spellRange && message.spellRange.length) {
                object.spellRange = [];
                for (let j = 0; j < message.spellRange.length; ++j)
                    object.spellRange[j] = message.spellRange[j];
            }
            return object;
        };

        /**
         * Converts this AppRoot to JSON.
         * @function toJSON
         * @memberof SpellCard.AppRoot
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AppRoot.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AppRoot;
    })();

    return SpellCard;
})();

export { $root as default };
